import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Eden Prairie, MN?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Eden Prairie typically takes 2–6 months. For Eden Prairie's business travelers and families with international plans, that standard timeline is not workable.",
  },
  {
    q: "Can I get an expedited passport for a medical device or tech conference?",
    a: "Absolutely. Eden Prairie has a high concentration of medical device and technology companies whose employees travel internationally on compressed schedules. We regularly process expedited renewals and new passports for Eden Prairie professionals — as fast as 2–9 business days.",
  },
  {
    q: "What acceptance facilities are near Eden Prairie?",
    a: "The Eden Prairie Post Office on Den Road accepts passport applications by appointment. Minnetonka, Chanhassen, and Plymouth post offices are nearby alternatives. For first-time applicants and minors, we provide exact guidance on which facility is best for your situation.",
  },
  {
    q: "Can my teenager get a passport quickly for a school trip abroad?",
    a: "Yes. Eden Prairie High School students and school-trip participants often need first-time passports on compressed timelines. Minors require an in-person acceptance clerk visit with parental participation. We guide families through the exact process so the passport is ready before the trip departs.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Eden Prairie travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Eden Prairie. Start your order online, follow the checklist, and ship overnight from anywhere in the southwest metro.",
  },
  {
    q: "What documents do I need for an expedited passport in Eden Prairie?",
    a: "For renewals: your current or recently expired passport, DS-82 form, two passport photos, and payment. For new passports: proof of citizenship, photo ID, DS-11 form, and passport photos. We provide a personalized checklist after you start your order and review every document before submission.",
  },
  {
    q: "Can Chanhassen and Minnetonka residents use this service?",
    a: "Absolutely. We serve all southwest metro communities including Chanhassen, Minnetonka, Chaska, Plymouth, and Shakopee with the same expedited processing as Eden Prairie residents. Since we operate remotely, your physical location in the area does not affect processing speed.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
  },
];

export default function EdenPrairieFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Eden Prairie and southwest metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}